import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { toast } from 'sonner';
import apiClient from '@/services/apiClient';
import { ReturnCard } from './ReturnCard';
import { errMsg } from './srUtils';

/** Pending returns (approve / reject) or History (approved + rejected, with the challan). */
export const ReturnsList = ({ section, mode, refreshKey, onChanged }) => {
  const [rows, setRows] = useState(null);
  const [can, setCan] = useState(false);
  const [q, setQ] = useState('');
  const [status, setStatus] = useState(mode === 'pending' ? 'PENDING' : 'ALL');

  const load = useCallback(() => {
    setRows(null);
    apiClient.get('/supplier-returns', { params: { section, q, status: status === 'ALL' ? '' : status } })
      .then((r) => { setCan(!!r.data.can_approve); setRows((r.data.returns || []).filter((x) => mode === 'pending' || x.status !== 'PENDING')); })
      .catch((e) => { setRows([]); toast.error(errMsg(e, 'Failed to load returns')); });
  }, [section, q, status, mode]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load, refreshKey]);

  return (
    <div className="space-y-3" data-testid={`sr-list-${mode}`}>
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search return no, supplier, document, bundle, sort no" className="pl-9 h-11" data-testid={`sr-search-${mode}`} />
        </div>
        {mode === 'history' && (
          <ToggleGroup type="single" value={status} onValueChange={(v) => v && setStatus(v)} className="justify-start">
            <ToggleGroupItem value="ALL" data-testid="sr-history-all">All</ToggleGroupItem>
            <ToggleGroupItem value="APPROVED" data-testid="sr-history-approved">Returned</ToggleGroupItem>
            <ToggleGroupItem value="REJECTED" data-testid="sr-history-rejected">Rejected</ToggleGroupItem>
          </ToggleGroup>
        )}
      </div>
      {rows === null ? <Loader2 className="w-6 h-6 animate-spin text-[#B45309] mx-auto" />
        : rows.length === 0 ? <p className="text-sm text-gray-500 text-center py-10" data-testid={`sr-empty-${mode}`}>{mode === 'pending' ? 'No returns waiting for approval.' : 'No returns yet.'}</p>
          : <div className="grid gap-3 lg:grid-cols-2">{rows.map((r) => <ReturnCard key={r.return_id} r={r} canApprove={can} onChanged={onChanged} />)}</div>}
    </div>
  );
};
